import ResourceList from './ResourceList';
import ResourceEdit from './ResourceEdit';
import icon from '../../icon/IcnSettingRoom';

export default {
    list: ResourceList,
    edit: ResourceEdit,
    icon: icon, 
}